import { EmptyStateColumn } from './empty-state-column'
import React from 'react'
import { ContrastFormattedMessage } from '../contrast-formatted-message'

export function FlowMapEmptyColumn({
  titleI18n,
  descriptionI18n
}: {
  readonly titleI18n: string
  readonly descriptionI18n: string
}) {
  return (
    <ContrastFormattedMessage id={titleI18n}>
      {(title) => (
        <ContrastFormattedMessage id={descriptionI18n}>
          {(description) => (
            <EmptyStateColumn title={title} description={description} />
          )}
        </ContrastFormattedMessage>
      )}
    </ContrastFormattedMessage>
  )
}
